import { chip } from "./chip";
import { customPortfolio } from "./custom-portfolio";
import { date } from "./date";
import { error } from "./error";
import { forecast } from "./forecast";

export type Lang = keyof typeof translations;
export type Translation =
  | (typeof translations)["zh"]
  | (typeof translations)["en"];

const translations = {
  zh: {
    monthlyAvgPrice: "月均價",
    forecast: forecast.zh,
    date: date.zh,
    error: error.zh,
    chip: chip.zh,
    customPortfolioReturns: customPortfolio.zh,
    currency: ({ currency }: { currency: string }) => {
      switch (currency) {
        case "USD":
          return "單位: 美元";
        case "TWD":
          return "單位: 新台幣";
        default:
          return `單位: ${currency}`;
      }
    },
  },
  en: {
    monthlyAvgPrice: "Average Monthly Price",
    date: date.en,
    forecast: forecast.en,
    error: error.en,
    chip: chip.en,
    customPortfolioReturns: customPortfolio.en,
    currency: ({ currency }: { currency: string }) => {
      switch (currency) {
        case "USD":
          return "Unit: USD";
        case "TWD":
          return "Unit: TWD";
        default:
          return `Unit: ${currency}`;
      }
    },
  },
};

export const getTranslation = ({ lang }: { lang: Lang }) => ({
  t: translations[lang],
});

export default translations;
